<template>
    <div :class="itemClass">
        <div class="notification-item notification-item-header">
            <div class="point unread-point" v-if="!item.Read"></div>
            <div class="point" v-else></div>
            <div class="notification-time">{{ dayDateTime(item.CreatedUtc) }}</div>
            <div class="readAndMark cursor-pointer" style="float:right" @click="readAndMark">
                转为已读
            </div>
        </div>
        <div class="notification-item notification-item-body">
            <div class="point"></div>
            <span class="workflowHandler notification-todo cursor-pointer" @click="goWorkflow(item.WorkflowId)"
                :data-view="'/api/workflowDetial/'+ item.WorkflowId">
                工作流直达
            </span>
            <div class="notification-message">
                <div class="notification-message-title">
                    {{ item.Message }}
                    <a v-if="!showBody && item.ShowToDo" class="cursor-pointer notification-todo" :href="item.ToDo" target="_blank">立即处理</a>
                </div>
                <div class="notification-message-body" v-if="showBody">
                    <div v-if="item.IsHtmlBody" style="display: flex;">
                        <div v-html="item.Body"></div>
                        <a v-if="item.ShowToDo" class="cursor-pointer notification-todo" :href="item.ToDo" target="_blank">立即处理</a>
                    </div>
                    <div v-else>{{ item.Body }} <a v-if="item.ShowToDo" class="cursor-pointer notification-todo" :href="item.ToDo" target="_blank">立即处理</a></div>
                </div>
            </div>
        </div>

        <div class="bottom-line"></div>
    </div>
</template>

<style>
    .workflowHandler{
        display: none;
    }

    .notification-todo{
        margin-left: 0.5rem;
        color:rgb(64, 158, 255);
    }

    .notification-item-body .notification-message-title {
        margin-top: 8px;
        letter-spacing: 1px;
        line-height: 28px;
        font-size: 16px;
        color: rgb(20, 30, 49);
        width: 100%;
    }
    .notification-item-body .notification-message-body {
        letter-spacing: 1px;
        line-height: 28px;
        font-size: 14px;
        color: rgb(20, 30, 49);
        width: 100%;
        margin-bottom: 8px;
    }

    .read-notification {
        color:rgb(131, 136, 146) 
    }

    .read-notification .notification-todo {
        color:rgb(131, 136, 146);
    }
    .read-notification .notification-message-title {
        color:rgb(131, 136, 146) 
    }
    .read-notification .notification-message-body {
        color:rgb(131, 136, 146) 
    }

    .notification-item-header{
        line-height: 28px;
        font-size:14px;
        margin-top:10px;
    }

    .notification-item{
        display: flex;
        align-items: center;
    }

    .notification-time{
        flex-grow: 1;
    }

    .point{
        width: 10px;
    }

    .unread-point::before{
        vertical-align: super;
        display:inline-block;
        content:"";
        border-radius:5px;
        width:5px;
        height:5px;
        background-color:red;
    }

    .readAndMark{
        display: none;
        color:rgb(64, 158, 255)
    }

    .noread-notification:hover .readAndMark{
        display:block
    }

    .bottom-line{
        border-bottom: 1px solid #e6e8ed;
    }
</style>

<script>
    import { dayDateTime, qweIsEmpty} from "../../common/commonHelper"

    export default {
        emits:[
            "changeReadState"
        ],
        props:{
            item:Object
        },
        computed:{
            itemClass:function(){
                return this.item.Read ? "read-notification" : "noread-notification"
            },

            showBody:function(){
                return !qweIsEmpty(this.item.Body);
            }
        },
        methods:{
            dayDateTime:function(date){
                return dayDateTime(date);
            },

            readAndMark:function(){
                this.$emit("changeReadState",this.item.MessageId);
            },

            goWorkflow:function(workflowId){
                window.open(this.$store.state.baseUrl + "/api/workflowDetial/"+workflowId,"_blank");
            }
        }
    }
</script>